import { defineMessages } from 'react-intl';

export const addReviewCallToActionMessages = defineMessages({
  text: {
    id: 'customerReviews.addReviewCallToAction.text',
    defaultMessage: 'Verfasse eine Bewertung',
  },
});
